import React, { useState, useEffect } from "react";
import { Card, Col, Row, Tabs, Tab, Button, Modal } from "react-bootstrap";
import { Link, useLocation } from "react-router-dom";
import avatar1 from "../../../assets/img/default.jpg";
import avatar2 from "../../../assets/img/avatars/4.png";
import { Icon } from "@iconify/react";
import DataTable from "react-data-table-component";
import { partialUsers } from "../../../common/api";
import { format } from "date-fns";
import ConfigApp from "../../../common/config";
import Sentry from "react-activity/dist/Sentry";

export default function Viewuser() {
  const { userId } = useLocation().state;
  const { dashboard } = useLocation().state;
  console.log(userId);
  const [key, setKey] = useState("followers");
  const [searchText, setSearchText] = useState("");
  const [userData, setUserData] = useState(null);
  const [loading, setLoading] = useState(false);
  const [followers, setFollowers] = useState([]);
  const [following, setFollowing] = useState([]);
  const [posts, setPosts] = useState([]);
  const [balance, setBalance] = useState(0);

  // Followers data
  const [show, setShow] = useState(false);
  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);

  const userDetails = async () => {
    setLoading(true);
    const token = localStorage.getItem("token");
    const dict = {
      userId: userId,
    };
    const response = await partialUsers(token, dict);
    console.log("response", response);
    setLoading(false);
    if (response.success === true) {
      setUserData(response.data.user);
      setFollowers(response.data.followers);
      setFollowing(response.data.following);
      setPosts(response.data.posts);
      setBalance(response.data.wallet);
    }
  };

  useEffect(() => {
    userDetails();
  }, [userId]);

  const columns = [
    {
      name: "Sr. No.",
      width: "100px",
      selector: (row, index) => index + 1,
      sortable: true,
      cell: (row, index) => index + 1,
    },
    {
      name: "Name",
      minWidth: "220px",
      selector: (row) => row?.full_name,
      sortable: true,
      cell: (row) => (
        <>
          <img
            className="table_img rounded-circle img-thumbnail me-2"
            src={
              row?.profile_url
                && row?.profile_url.startsWith("http")
                  ? row.profile_url
                  : row?.profile_url?`${ConfigApp.IMAGE_URL}${row.profile_url}`
                : avatar1
            }
            alt=""
          />
          {row?.full_name ? row?.full_name : "N/A"}
        </>
      ),
    },
    {
      name: "Followers",
      minWidth: "190px",
      selector: (row) => row?.followerCount,
      sortable: true,
      cell: (row) => (row?.followerCount ? row?.followerCount : "N/A"),
    },
    // {
    //   name: "Actions",
    //   cell: (row) => (
    //     <>
    //       <Link className="btndelete" onClick={handleShow}>
    //         <Icon icon="tabler:trash"></Icon>
    //       </Link>
    //     </>
    //   ),
    // },
  ];
  const [data] = useState([
    {
      id: 1,
      name: "Laila",
      imgurl: avatar1,
      follower: "5.2K",
    },
    {
      id: 2,
      name: "Mai My Oanh",
      imgurl: avatar2,
      follower: "6.3K",
    },
    {
      id: 3,
      name: "Zaire Hassan",
      imgurl: avatar1,
      follower: "5.2K",
    },
    {
      id: 4,
      name: "Kianna Rhiel Madsen",
      imgurl: avatar2,
      follower: "5.3K",
    },
    {
      id: 5,
      name: "Rayna Lubin",
      imgurl: avatar1,
      follower: "5.2K",
    },
    {
      id: 6,
      name: "Zaire Kenter",
      imgurl: avatar2,
      follower: "5.2K",
    },
    {
      id: 7,
      name: "Jaxson Korsgaard",
      imgurl: avatar1,
      follower: "2.1K",
    },
  ]);
  // Filter data based on search text
  const filteredData =
    followers && followers.length > 0
      ? followers.filter(
          (item) =>
            JSON.stringify(item)
              .toLowerCase()
              .indexOf(searchText.toLowerCase()) !== -1
        )
      : [];

  // Follwoing data

  // const getStatusStyle = (status) => {
  //   switch (status) {
  //     case "Active":
  //       return {
  //         backgroundColor: "rgba(40, 199, 111, 0.12)",
  //         color: "#28c76f",
  //         padding: "5px 10px",
  //         borderRadius: "5px",
  //         display: "inline-block",
  //       };
  //     case "In Active":
  //       return {
  //         backgroundColor: "rgba(146, 0, 0, 0.12)",
  //         color: "#920000",
  //         padding: "5px 10px",
  //         borderRadius: "5px",
  //         display: "inline-block",
  //       };
  //     default:
  //       return {};
  //   }
  // };
  const columns1 = [
    {
      name: "Sr. No.",
      width: "100px",
      selector: (row, index) => index + 1,
      sortable: true,
      cell: (row, index) => index + 1,
    },
    {
      name: "Name",
      minWidth: "220px",
      selector: (row) => row?.full_name,
      sortable: true,
      cell: (row) => (
        <>
          <img
            className="table_img rounded-circle img-thumbnail me-2"
            src={
              row.profile_url.startsWith("http")
                ? row.profile_url
                : row.profile_url
                ? `${ConfigApp.IMAGE_URL}${row.profile_url}`
                : avatar1
            }
            alt=""
          />
          {row?.full_name ? row?.full_name : "N/A"}
        </>
      ),
    },
    {
      name: "Following",
      minWidth: "190px",
      selector: (row) => row?.followerCount,
      sortable: true,
      cell: (row) => (row?.followerCount ? row?.followerCount : "N/A"),
    },
    // {
    //   name: "Actions",
    //   cell: (row) => (
    //     <>
    //       <Link className="btndelete" onClick={handleShow}>
    //         <Icon icon="tabler:trash"></Icon>
    //       </Link>
    //     </>
    //   ),
    // },
  ];
  const [data1] = useState([
    {
      id: 1,
      name: "Laila",
      imgurl: avatar1,
      follower: "5.2K",
    },
    {
      id: 2,
      name: "Mai My Oanh",
      imgurl: avatar2,
      follower: "6.3K",
    },
    {
      id: 3,
      name: "Zaire Hassan",
      imgurl: avatar1,
      follower: "5.2K",
    },
    {
      id: 4,
      name: "Kianna Rhiel Madsen",
      imgurl: avatar2,
      follower: "5.3K",
    },
    {
      id: 5,
      name: "Rayna Lubin",
      imgurl: avatar1,
      follower: "5.2K",
    },
    {
      id: 6,
      name: "Zaire Kenter",
      imgurl: avatar2,
      follower: "5.2K",
    },
    {
      id: 7,
      name: "Jaxson Korsgaard",
      imgurl: avatar1,
      follower: "2.1K",
    },
  ]);
  // Filter data based on search text
  const filteredData1 =
    following && following.length > 0
      ? following.filter(
          (item) =>
            JSON.stringify(item)
              .toLowerCase()
              .indexOf(searchText.toLowerCase()) !== -1
        )
      : [];

  // Post data
  const columns2 = [
    {
      name: "Sr. No.",
      width: "100px",
      selector: (row, index) => index + 1,
      sortable: true,
      cell: (row, index) => index + 1,
    },
    {
      name: "About Post",
      minWidth: "220px",
      selector: (row) => row?.about_post,
      sortable: true,
      cell: (row) => (
        <div
          style={{
            maxHeight: "100px",
            overflowY: "auto",
            whiteSpace: "pre-wrap",
            paddingRight: "8px"
          }}
        >
        {row?.about_post ? row?.about_post : "N/A"}
        </div>
      ),
    },
    {
      name: "Date",
      minWidth: "190px",
      selector: (row) => formatDate(row?.createdAt),
      sortable: true,
      cell: (row) => formatDate(row?.createdAt),
    },
    // {
    //   name: "Comments",
    //   minWidth: "190px",
    //   selector: (row) =>
    //     row?.latestComment?.comment ? row?.latestComment?.comment : "N/A",
    //   sortable: true,
    //   cell: (row) => (
    //     <div
    //       style={{
    //         maxHeight: "100px",
    //         overflowY: "auto",
    //         whiteSpace: "pre-wrap",
    //         paddingRight: "8px",
    //       }}
    //     >
    //       {row?.latestComment?.comment ? row?.latestComment?.comment : "N/A"}
    //     </div>
    //   ),
    // },
    {
      name: "Web Link",
      minWidth: "190px",
      selector: (row) => (row?.web_link ? row?.web_link : "N/A"),
      sortable: true,
      cell: (row) => (row?.web_link ? row?.web_link : "N/A"),
    },
    {
      name: "Actions",
      cell: (row) => (
        <>
          <Link
            className="btnview"
            to="/posts/view-post"
            state={{ postId: row._id, status: "view" }}
          >
            <Icon icon="tabler:eye"></Icon>
          </Link>
          <Link className="btndelete" onClick={handleShow}>
            <Icon icon="tabler:trash"></Icon>
          </Link>
        </>
      ),
    },
  ];
  const [data2] = useState([
    {
      id: 1,
      name: "Laila",
      imgurl: avatar1,
      date: "2024-01-01",
      comments: "Great content!",
      description: "Actively engages with followers.",
    },
    {
      id: 2,
      name: "Mai My Oanh",
      imgurl: avatar2,
      date: "2024-01-01",
      comments: "Very interactive.",
      description: "Focuses on lifestyle and health topics.",
    },
    {
      id: 3,
      name: "Zaire Hassan",
      imgurl: avatar1,
      date: "2024-01-01",
      comments: "Shares useful insights.",
      description: "Promotes educational content.",
    },
    {
      id: 4,
      name: "Kianna Rhiel Madsen",
      imgurl: avatar2,
      date: "2024-01-01",
      comments: "Posts regularly.",
      description: "Creates visually engaging posts.",
    },
    {
      id: 5,
      name: "Rayna Lubin",
      imgurl: avatar1,
      date: "2024-01-01",
      comments: "Lots of Q&A.",
      description: "Engages in community discussions.",
    },
    {
      id: 6,
      name: "Zaire Kenter",
      imgurl: avatar2,
      date: "2024-01-01",
      comments: "Friendly and open.",
      description: "Supports mental wellness.",
    },
    {
      id: 7,
      name: "Jaxson Korsgaard",
      imgurl: avatar1,
      date: "2024-01-01",
      comments: "Growing quickly.",
      description: "New content creator in tech niche.",
    },
  ]);

  // Filter data based on search text
  const filteredData2 =
    posts && posts.length > 0
      ? posts.filter(
          (item) =>
            JSON.stringify(item)
              .toLowerCase()
              .indexOf(searchText.toLowerCase()) !== -1
        )
      : [];
  const formatDate = (dateString) => {
    return format(new Date(dateString), "dd-MM-yyyy");
  };

  console.log("followers", followers);

  return (
    <React.Fragment>
      {loading ? (
        <Sentry
          color="#2B5AAC"
          size={30}
          speed={1}
          animating={true}
          style={{ marginLeft: "45%", marginTop: "20%" }}
        />
      ) : (
        <>
          <Card className="mb-3">
            <Card.Header className="d-flex align-items-center justify-content-between flex-wrap">
              <h5>User Details</h5>
              <Link
                className="btn btn-primary2 d-inline-flex align-items-center justify-content-center px-4 min_width140"
                to={dashboard ? "/dashboard" : "/users"}
              >
                Back
              </Link>
            </Card.Header>

            <Card.Body className="mt-3">
              <div className="taledtl_div">
                <Row>
                  <Col md="4">
                    <div className="talefile_box">
                      <img
                        className="talefile_img"
                        src={
                          userData && userData?.profile_url!=null&&userData?.profile_url.startsWith("http")
                            ? userData?.profile_url
                            : userData?.profile_url
                            ? `${ConfigApp.IMAGE_URL}${userData?.profile_url}`
                            : avatar1
                        }
                        alt=""
                      />
                    </div>
                  </Col>
                  <Col md="8">
                    <div className="talefile_list">
                      <div className="tablefilelist_grid">
                        <h4>Name</h4>
                        <p>{userData && userData?.full_name}</p>
                      </div>

                      <div className="tablefilelist_grid">
                        <h4>Email</h4>
                        <p>{userData && userData?.email}</p>
                      </div>

                      <div className="tablefilelist_grid">
                        <h4>UserName</h4>
                        <p>{userData && userData?.user_name}</p>
                      </div>
                      <div className="tablefilelist_grid">
                        <h4>Type</h4>
                        <p>{userData && userData?.login_type}</p>
                      </div>
                      <div className="tablefilelist_grid">
                        <h4>Phone Number</h4>
                        <p>
                          {userData && userData?.phone_number
                            ? userData?.phone_number
                            : "N/A"}
                        </p>
                      </div>
                      <div className="tablefilelist_grid">
                        <h4>Created On</h4>
                        <p>{userData && formatDate(userData?.createdAt)}</p>
                      </div>
                      <div className="tablefilelist_grid">
                        <h4>Balance</h4>
                        <p>${balance && balance?.balance}</p>
                      </div>
                      <div className="tablefilelist_grid">
                        <h4>Total Spent</h4>
                        <p>${balance && balance?.totalSpent}</p>
                      </div>
                      <div className="tablefilelist_grid">
                        <h4>Location</h4>
                        <p>{userData && userData?.location}</p>
                      </div>
                      <div className="tablefilelist_grid">
                        <h4>Age</h4>
                        <p>
                          {userData?.ageGroup
                            ? `${userData.ageGroup.min} - ${userData.ageGroup.max}`
                            : "N/A"}
                        </p>
                      </div>
                      <div className="tablefilelist_grid">
                        <h4>Gender</h4>
                        <p>{userData && userData?.gender}</p>
                      </div>
                      <div className="tablefilelist_grid">
                        <h4>Interests</h4>
                        <p>
                          {userData?.interests && userData.interests.length > 0
                            ? userData.interests.join(", ")
                            : "N/A"}
                        </p>
                      </div>
                      <div className="tablefilelist_grid">
                        <h4>Status</h4>
                        <p className="mt-2">
                          <span
                            className={`${
                              userData && userData?.is_active === "0"
                                ? "Active"
                                : "In Active"
                            } badge`}
                          >
                            {userData && userData?.is_active === "0"
                              ? "Active"
                              : "In Active"}
                          </span>
                        </p>
                      </div>
                    </div>
                  </Col>
                </Row>
              </div>
            </Card.Body>
          </Card>
          <Card>
            <Card.Body>
              <Tabs
                defaultActiveKey="basicinfo"
                id="uncontrolled-tab-example"
                className="customtabs mb-2"
                activeKey={key}
                onSelect={(k) => setKey(k)}
              >
                <Tab eventKey="followers" title="Followers">
                  <Row>
                    {followers && followers.length > 0 ? (
                      followers.map((item, index) => (
                        <Col key={index} md={4} className="mb-4">
                          <div className="stats">
                            <img
                              className="table_img rounded-circle img-thumbnail"
                              src={
                                item.profile_url.startsWith("http")
                                  ? item.profile_url
                                  : item.profile_url
                                  ? `${ConfigApp.IMAGE_URL}${item.profile_url}`
                                  : avatar1
                              }
                              alt=""
                              style={{ width: "70px", height: "70px" }}
                            />
                            <div className="stats-cont">
                              <h4 className="mb-0">{item.full_name}</h4>
                              <h4 className="mb-0">{item.email}</h4>
                            </div>
                          </div>
                        </Col>
                      ))
                    ) : (
                      <div
                      style={{
                        display: "flex",
                        justifyContent: "center", // Horizontal center
                        alignItems: "center", // Vertical center
                      }}
                    >
                      <p>No follower found.</p>
                    </div>
                    )}

                    {/* <Col md="3">
                      <div className="stats">
                        <img
                          className="table_img rounded-circle img-thumbnail"
                          src={avatar1}
                          alt=""
                          style={{ width: "70px", height: "70px" }}
                        />
                        <div className="stats-cont">
                          <h4 className="mb-0">Total Users</h4>
                        </div>
                      </div>
                    </Col> */}
                  </Row>
                  {/* <div className="text-end mb-3">
                    <input
                      type="text"
                      placeholder="Search..."
                      className="searchfield"
                      value={searchText}
                      onChange={(e) => setSearchText(e.target.value)}
                    />
                  </div>
                  <DataTable
                    columns={columns}
                    data={filteredData}
                    pagination
                    responsive
                    className="custom-table"
                  /> */}
                </Tab>
                <Tab eventKey="following" title="Following">
                  <Row>
                    {following && following.length > 0 ? (
                      following.map((item, index) => (
                        <Col key={index} md={4} className="mb-4">
                          <div className="stats">
                            <img
                              className="table_img rounded-circle img-thumbnail"
                              src={
                                item.profile_url.startsWith("http")
                                  ? item.profile_url
                                  : item.profile_url
                                  ? `${ConfigApp.IMAGE_URL}${item.profile_url}`
                                  : avatar1
                              }
                              alt=""
                              style={{ width: "70px", height: "70px" }}
                            />
                            <div className="stats-cont">
                              <h4 className="mb-0">{item.full_name}</h4>
                              <h4 className="mb-0">{item.email}</h4>
                            </div>
                          </div>
                        </Col>
                      ))
                    ) : (
                      <div
                        style={{
                          display: "flex",
                          justifyContent: "center", // Horizontal center
                          alignItems: "center", // Vertical center
                        }}
                      >
                        <p>No following found.</p>
                      </div>
                    )}
                  </Row>
                  {/* <div className="text-end mb-3">
                    <input
                      type="text"
                      placeholder="Search..."
                      className="searchfield"
                      value={searchText}
                      onChange={(e) => setSearchText(e.target.value)}
                    />
                  </div>
                  <DataTable
                    columns={columns1}
                    data={filteredData1}
                    pagination
                    responsive
                    className="custom-table"
                  /> */}
                </Tab>
                <Tab eventKey="postusers" title="Posts">
                  <div className="text-end mb-3">
                    <input
                      type="text"
                      placeholder="Search..."
                      className="searchfield"
                      value={searchText}
                      onChange={(e) => setSearchText(e.target.value)}
                    />
                  </div>
                  <DataTable
                    columns={columns2}
                    data={filteredData2}
                    pagination
                    responsive
                    className="custom-table"
                  />
                </Tab>
              </Tabs>
            </Card.Body>
          </Card>
        </>
      )}

      <Modal className="modal_Delete" show={show} onHide={handleClose} centered>
        <Modal.Body>
          <div className="modaldelete_div">
            <Icon className="delete_icon" icon="gg:close-o"></Icon>
            <h3>Are You Sure ?</h3>
            <p>You will not be able to recover the deleted record!</p>
          </div>
          <Button
            variant="outline-danger"
            onClick={handleClose}
            className="px-4 me-3"
          >
            Cancel
          </Button>
          <Button
            variant="success"
            className="px-4 min_width110"
            onClick={handleClose}
          >
            Ok
          </Button>
        </Modal.Body>
      </Modal>
    </React.Fragment>
  );
}
